import React, { useCallback, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import ReactCrop, { type Crop } from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export const ImageCropComponent = ({
  src,
  isVisible,
  onImageCropped,
  dimensions = { width: 256, height: 256 },
}: {
  src: string | null;
  isVisible: boolean;
  onImageCropped?: Function;
  dimensions?: { width: number; height: number };
}) => {
  const [crop, setCrop] = useState<Crop>({
    unit: "px",
    width: dimensions.width,
    height: dimensions.height,
    x: 0,
    y: 0,
  });
  const [croppedImageUrl, setCroppedImageUrl] = useState<string | null>(null);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const onImageLoad = useCallback((e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    imgRef.current = e.currentTarget;
  }, []);

  const getCroppedImg = useCallback(async () => {
    if (!imgRef.current || !crop.width || !crop.height) return;
    const canvas = document.createElement("canvas");
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    ctx.drawImage(
      imgRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height,
    );

    return new Promise<string>((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }
        const fileUrl = window.URL.createObjectURL(blob);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  }, [crop]);

  const onCropComplete = (crop: Crop) => {
    // Handle the complete crop operation here
    console.log("Crop complete:", crop);
  };

  const onCropChange = (crop: Crop, percentCrop: any) => {
    console.log("Crop change:", crop, percentCrop);
    setCrop(crop);
  };

  const handleSubmit = async () => {
    const croppedImgUrl = await getCroppedImg();

    if (!croppedImgUrl) {
      return;
    }

    setCroppedImageUrl(croppedImgUrl);
    if (onImageCropped) {
      onImageCropped(croppedImgUrl);
    }
  };

  return (
    <Modal show={isVisible} size="lg" centered={true}>
      <Modal.Body>
        {src && (
          <ReactCrop
            crop={crop}
            ruleOfThirds
            onComplete={onCropComplete}
            onChange={onCropChange}
            aspect={1}
            minWidth={dimensions.width}
            minHeight={dimensions.height}
            maxHeight={dimensions.height}
            maxWidth={dimensions.width}
          >
            {/* Moved the onLoad handler to the <img> element */}
            <img src={src} alt="Crop target" onLoad={onImageLoad} />
          </ReactCrop>
        )}
        {/* {croppedImageUrl && <img alt="Crop preview" src={croppedImageUrl} />} */}
      </Modal.Body>
      <Modal.Footer>
        <button>Close</button>
        <button onClick={handleSubmit}>Submit</button>
      </Modal.Footer>
    </Modal>
  );
};
